import { createSelector } from 'reselect'

import { selectStrategicInitiativesState } from './selectStrategicInitiativesState'

export const selectStrategicInitiativesSelectedFYear = createSelector(
  [selectStrategicInitiativesState],
  (state) => state.selectedFYear
)
